import { Text, ArrowSvg } from 'react-gldn-kit';
import { useNavigate } from 'react-router';

import { BASE_URL } from 'constants/transport';
import { APP_TYPE } from 'constants/ui';

import { useZustandModalStore } from 'stores/modal/store';
import { closeAndOpenModalAction } from 'stores/modal/selectors';

import { ModalTypes } from 'stores/modal/types';
import { ERouteNames } from 'Routes/types';

import styles from './PromotionBanner.module.css';

const PromotionBanner = () => {
  const navigate = useNavigate();

  const closeModal = useZustandModalStore(closeAndOpenModalAction);

  const jumpTo = () => {
    closeModal(ModalTypes.Unknown);

    navigate(ERouteNames.NYPromo);
  };

  return (
    <div
      className={styles.wrapperPromotionBanner}
      style={{
        backgroundImage: `url(${BASE_URL}/icons-elon/landings/promotions/${APP_TYPE}/buttonBackground.png)`,
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className={styles.title}>
        <Text idT="bigGive.button" />
      </div>

      <div className={styles.moreDetailed} onClick={jumpTo}>
        <div>
          <Text idT="tournaments.banners.moreDetailed" />
        </div>
        <ArrowSvg classes={styles.arrowSvg} width={16} height={9} />
      </div>
    </div>
  );
};

export default PromotionBanner;
